<template>
  <div class="device-management-page">
    <!-- 顶部导航栏 - 参考 information 页面 -->
    <header class="device-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <div class="nav-back-wrapper">
          <button class="nav-back-btn" @click="goBack">
            <i class="el-icon-arrow-left"></i>
          </button>
        </div>
        <div class="nav-title">设备管理</div>
        <div class="nav-after-sales" @click="goToAfterSales">
          <span>售后</span>
        </div>
      </div>
    </header>

    <!-- 移动端设备列表 -->
    <div class="mobile-device-list" v-if="!isLoading"  :style="{paddingTop: (statusBarHeight+80) + 'px'}">
      <!-- 健康监测智能手表 -->
      <div class="mobile-device-card" :class="{ 'device-connected': deviceBindingStatus.watch }">
        <!-- 已连接标签 -->
        <div v-if="deviceBindingStatus.watch" class="connected-badge">
          <img src="@/assets/deviceList/alreadyBoundicon.png" alt="已连接" class="check-icon" :style="{ width: $px2rem(13), height: $px2rem(13), objectFit: 'contain' }" />
          <span>已连接</span>
        </div>
        <div class="device-left">
          <div class="device-avatar">
            <img :src="imgWatch" alt="智能手表" class="device-image">
          </div>
          <div class="device-info">
            <h3 class="device-title">智能手表</h3>
            <p class="device-subtitle">健康监测设备</p>
            <p v-if="deviceBindingStatus.watch && deviceDetails.watch && deviceDetails.watch.deviceCode" class="device-imei">
              IMEI：{{ deviceDetails.watch.deviceCode }}
            </p>
          </div>
        </div>
        <div class="device-right">
          <button 
            class="mobile-action-btn" 
            :class="{ 'unbind-btn': deviceBindingStatus.watch, 'bind-btn': !deviceBindingStatus.watch }"
            @click="toggleDeviceBinding('watch',deviceBindingStatus)"
            :style="deviceBindingStatus.watch 
              ? 'background: linear-gradient(135deg, #FF6B9D 0%, #FF8FA3 100%); box-shadow: 0 2px 8px rgba(255, 107, 157, 0.2);' 
              : 'background: linear-gradient(135deg, #00C275 0%, #45D968 100%); box-shadow: 0 2px 8px rgba(0, 194, 117, 0.2);'"
          >
            {{ deviceBindingStatus.watch ? '解绑' : '扫码绑定' }}
          </button>
        </div>
      </div>

      <!-- 血压计 -->
      <div class="mobile-device-card" :class="{ 'device-connected': deviceBindingStatus.bloodPressure }">
        <!-- 已连接标签 -->
        <div v-if="deviceBindingStatus.bloodPressure" class="connected-badge">
          <img src="@/assets/deviceList/alreadyBoundicon.png" alt="已连接" class="check-icon" :style="{ width: $px2rem(13), height: $px2rem(13), objectFit: 'contain' }" />
          <span>已连接</span>
        </div>
        <div class="device-left">
          <div class="device-avatar">
            <img :src="imgBp" alt="血压计" class="device-image">
          </div>
          <div class="device-info">
            <h3 class="device-title">血压计</h3>
            <p class="device-subtitle">血压监测设备</p>
            <p v-if="deviceBindingStatus.bloodPressure && deviceDetails.bloodPressure && deviceDetails.bloodPressure.deviceCode" class="device-imei">
              IMEI：{{ deviceDetails.bloodPressure.deviceCode }}
            </p>
          </div>
        </div>
        <div class="device-right">
          <button 
            class="mobile-action-btn" 
            :class="{ 'unbind-btn': deviceBindingStatus.bloodPressure, 'bind-btn': !deviceBindingStatus.bloodPressure }"
            @click="toggleDeviceBinding('bloodPressure',deviceBindingStatus)"
            :style="deviceBindingStatus.bloodPressure 
              ? 'background: linear-gradient(135deg, #FF6B9D 0%, #FF8FA3 100%); box-shadow: 0 2px 8px rgba(255, 107, 157, 0.2);' 
              : 'background: linear-gradient(135deg, #00C275 0%, #45D968 100%); box-shadow: 0 2px 8px rgba(0, 194, 117, 0.2);'"
          >
            {{ deviceBindingStatus.bloodPressure ? '解绑' : '扫码绑定' }}
          </button>
        </div>
      </div>

      <!-- 动态心电记录仪 -->
      <div class="mobile-device-card" :class="{ 'device-connected': deviceBindingStatus.ecg }">
        <!-- 已连接标签 -->
        <div v-if="deviceBindingStatus.ecg" class="connected-badge">
          <img src="@/assets/deviceList/alreadyBoundicon.png" alt="已连接" class="check-icon" :style="{ width: $px2rem(13), height: $px2rem(13), objectFit: 'contain' }" />
          <span>已连接</span>
        </div>
        <div class="device-left" style="margin-top: 0px;">
          <div class="device-avatar">
            <img :src="imgEcg" alt="心电记录仪" class="device-image">
          </div>
          <div class="device-info">
            <h3 class="device-title">心电记录仪</h3>
            <p class="device-subtitle">心电监测设备</p>
            <p v-if="deviceBindingStatus.ecg && deviceDetails.ecg && deviceDetails.ecg.deviceCode" class="device-imei">
              IMEI：{{ deviceDetails.ecg.deviceCode }}
            </p>
            <p v-if="ecgStatus" class="device-status-text">
              {{ ecgStatus }}
            </p>
          </div>
        </div>
        <div class="device-right">
          <button 
            class="mobile-action-btn" 
            :class="{ 'unbind-btn': deviceBindingStatus.ecg, 'start-measure-btn': !deviceBindingStatus.ecg }"
            @click="toggleDeviceBinding('ecg',deviceBindingStatus)"
            :style="deviceBindingStatus.ecg 
              ? 'background: linear-gradient(135deg, #FF6B9D 0%, #FF8FA3 100%); box-shadow: 0 2px 8px rgba(255, 107, 157, 0.2);' 
              : 'background: linear-gradient(135deg, #00C275 0%, #45D968 100%); box-shadow: 0 2px 8px rgba(0, 194, 117, 0.2);'"
          >
            {{ deviceBindingStatus.ecg ? '解绑' : '开始测量' }}
          </button>
        </div>
      </div>
      
      <!-- 视频播放区域 -->
      <div class="video-player-section">
        <div class="video-player-container" @click="toggleVideoPlay">
          <img :src="imgVideoPoster" alt="视频背景" class="video-poster" v-if="!isVideoPlaying" />
          <video 
            ref="videoPlayer"
            :src="videoUrl" 
            class="video-player"
            controls
            v-if="!isInDjxApp"
            playsinline
            webkit-playsinline
            @play="onVideoPlay"
            @pause="onVideoPause"
            @ended="onVideoEnd"
            v-show="isVideoPlaying"
          ></video>
          <video 
            ref="videoPlayerApp"
            :src="videoUrl" 
            class="video-player"
            controls
            v-if="isInDjxApp"
            x5-playsinline="false"
            x5-video-player-type="native"
            x5-video-player-fullscreen="true"
            @play="onVideoPlay"
            @pause="onVideoPause"
            @ended="onVideoEnd"
            v-show="isVideoPlaying"
          ></video>
          <div class="video-play-btn" v-if="!isVideoPlaying">
            <div class="play-icon">▶</div>
          </div>
          <!-- 全屏按钮 -->
         
        </div>
      </div>
    </div>
    
    <!-- 加载状态 -->
    <div class="loading-container" v-if="isLoading">
      <div class="loading-spinner"></div>
      <p class="loading-text">正在加载设备信息...</p>
    </div>
    
    <!-- 紧急联系人弹出框 -->
    <van-dialog 
      v-model="contactsDialog" 
      title="紧急联系人添加" 
      :show-cancel-button="false"
      :close-on-click-overlay="false"
      :show-confirm-button="false"
    >
      <div class="contacts-dialog">
        <div class="contacts-tip">
          为了能更好地为您服务，方便提供一位紧急联系人吗？这样如果暂时联系不上您，我们也能通过他/她及时联系到您~
        </div>
        <div class="contacts-form">
          <van-field
            v-model="contactsForm.name"
            label="姓名"
            placeholder="请输入联系人姓名"
            :border="false"
            class="contacts-input"
          />
          <van-field
            v-model="contactsForm.phone"
            label="手机号"
            placeholder="请输入联系人手机号"
            type="tel"
            :border="false"
            class="contacts-input"
          />
        </div>
        <!-- 自定义确定按钮 -->
        <div class="contacts-button-wrapper">
          <van-button 
            type="primary" 
            color="#00C275"
            block 
            @click="addEmergencyContact"
            class="contacts-confirm-btn"
          >
            确定
          </van-button>
        </div>
      </div>
    </van-dialog>

    <!-- 使用步骤弹出框 -->
    <van-dialog 
      v-model="guideDialog" 
      :show-cancel-button="false"
      :show-confirm-button="false"
      :close-on-click-overlay="false"
      class="guide-dialog"
    >
      <div class="guide-content">
        <van-swipe 
          ref="guideSwipe"
          class="guide-swipe" 
          :show-indicators="true" 
          indicator-color="#00bb82"
          :touchable="true"
          :loop="false"
          @change="onStepChange"
        >
          <!-- 第一步：安装电池 -->
          <van-swipe-item>
            <div class="swipe-item-content">
              <img :src="imgGuideStep01" class="guide-image" alt="安装电池" />
              <div class="skip-btn" @click="skipGuide">跳过>></div>
              <div class="guide-text">
                <h3 class="guide-title">第一步 安装电池</h3>
                <p class="guide-desc">逆时针旋开后盖,</p>
                <p class="guide-desc">放入新的CR2032纽扣电池，电池正极(+)朝外,</p>
                <p class="guide-desc">顺时针旋上后盖</p>
              </div>
            </div>
          </van-swipe-item>
          
          <!-- 第二步：粘贴电极片 -->
          <van-swipe-item>
            <div class="swipe-item-content">
              <img :src="imgGuideStep02" class="guide-image" alt="粘贴电极片" />
              <div class="skip-btn" @click="skipGuide">跳过>></div>
              <div class="guide-text">
                <h3 class="guide-title">第二步 粘贴电极片</h3>
                <p class="guide-desc">将记录仪与电极片相连</p>
              </div>
            </div>
          </van-swipe-item>
          
          <!-- 第三步：佩戴记录仪 -->
          <van-swipe-item>
            <div class="swipe-item-content">
              <img :src="imgGuideStep03" class="guide-image" alt="佩戴记录仪" />
              <div class="skip-btn" @click="skipGuide">跳过>></div>
              <div class="guide-text">
                <h3 class="guide-title">第三步 佩戴记录仪</h3>
                <p class="guide-desc">指示灯和圆点标记朝上，以45度角贴于左胸上方</p>
              </div>
            </div>
          </van-swipe-item>
          
          <!-- 第四步：连接记录仪 -->
          <van-swipe-item>
            <div class="swipe-item-content">
              <img :src="imgGuideStep04" class="guide-image" alt="连接记录仪" />
              <div class="close-btn" @click="closeGuideDialog">
                <i class="el-icon-close"></i>
              </div>
              <div class="guide-text">
                <h3 class="guide-title">第四步 连接心电记录仪</h3>
                <p class="guide-desc">点击下方按钮，通过蓝牙连接记录仪</p>
              </div>
              <div class="guide-action">
                <van-button 
                  type="primary" 
                  color="#00C275"
                  size="large"
                  round
                  block
                  @click="connectDevice"
                  class="connect-btn"
                >
                  连接记录仪
                </van-button>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </van-dialog>
    
    <!-- 智能手表绑定提醒弹框 -->
    <div 
      v-if="watchBindingReminderDialog" 
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 20px;"
      @click.self="watchBindingCountdown <= 0 ? closeWatchBindingReminder() : null"
    >
      <div style="background: #ffffff; border-radius: 16px; width: 100%; max-width: 343px; overflow: hidden; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);">
        <!-- 弹框头部 -->
        <div style="display: flex; align-items: center; padding: 20px 20px 16px 20px; border-bottom: 1px solid #F0F0F0;">
          <!-- 警告图标 -->
          <div style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; margin-right: 12px; flex-shrink: 0;">
            <img src="@/assets/img/jg.png" alt="警告" style="width: 24px; height: 24px; object-fit: contain;" />
          </div>
          <!-- 标题 -->
          <h3 style="margin: 0; font-size: 18px; font-weight: 600; color: #000000; flex: 1;">重要提醒</h3>
        </div>
        
        <!-- 弹框内容 -->
        <div style="padding: 20px; line-height: 1.8; font-size: 15px; color: #333333;">
          <p style="margin: 0; text-align: left;">
            为保障您的权益安全,相关设备需本人实名捆绑后方可享受专属权益。非本人捆绑设备将无法履行权益内容、参与活动及享受售后保障,请务必按指引完成本人认证与捆绑操作。
          </p>
        </div>
        
        <!-- 确认按钮 -->
        <div style="padding: 0 20px 20px 20px;">
          <button 
            @click="closeWatchBindingReminder"
            :disabled="watchBindingCountdown > 0"
            style="width: 100%; height: 48px; background: linear-gradient(135deg, #00C275 0%, #45D968 100%); border: none; border-radius: 24px; color: #ffffff; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.3s ease; box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);"
            :style="watchBindingCountdown > 0 ? 'opacity: 0.6; cursor: not-allowed;' : 'opacity: 1;'"
          >
            {{ watchBindingCountdown > 0 ? `我知道了(${watchBindingCountdown}s)` : '我知道了' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useUserStore } from '@/stores/user';
import { useGlobalStore } from '@/stores/global';
import { devicelist,unbindbinddevice,contacts, addcontacts, binddeviceinfo, getBindDeviceList, binddevice, getSwkMeasurementsByUser } from '@/api/activity';
import { getMiniProgramConfig, generateMiniProgramUrl } from '@/config/miniProgram';
export default {
  data() {
    return {
      // 本地图片资源：使用 require 确保构建后路径稳定
      imgWatch: require('./img/new1.png'),
      imgBp: require('./img/xy.jpg'),
      imgEcg: require('./img/xd.jpg'),
      imgVideoPoster: require('./img/sp.jpg'),
      // 使用步骤弹窗本地图片（仅使用本地）
      imgGuideStep01: require('./img/step_01.jpg'),
      imgGuideStep02: require('./img/step_02.jpg'),
      imgGuideStep03: require('./img/step_03.jpg'),
      imgGuideStep04: require('./img/step_04.jpg'),
      constants: {},
      list:[],
      isLoading: true, // 加载状态
      contactsDialog: false, // 紧急联系人弹出框
      contactsForm: {
        name: '',
        phone: ''
      },
      // 设备绑定状态
      deviceBindingStatus: {
        watch: false,        // 健康监测智能手表
        bloodPressure: false, // 智能血压仪
        ecg: false          // 动态心电记录仪
      },
      // 设备详细信息，用于解绑时获取deviceCode和deviceType
      deviceDetails: {
        watch: null,        // 手表设备信息
        bloodPressure: null, // 血压仪设备信息
        ecg: null          // 心电设备信息
      },
      // 当前正在绑定的设备类型
      currentBindingDeviceType: null,
      // 使用步骤弹窗控制
      guideDialog: false, // 使用步骤弹窗
      currentStepIndex: 0, // 当前步骤索引
      imageBaseUrl: 'https://ecgstorage.blob.core.chinacloudapi.cn/swklite', // 图片基础路径
      // 心电记录仪状态
      ecgStatus: null, // 心电记录仪最新状态：null-无数据或不在两天内，其他为状态文字
      // 智能手表绑定提醒弹框
      watchBindingReminderDialog: false, // 是否显示智能手表绑定提醒弹框
      watchBindingCountdown: 5, // 倒计时秒数
      watchBindingCountdownTimer: null, // 倒计时定时器
      // 视频播放相关
      isVideoPlaying: false, // 视频是否正在播放
      videoUrl: 'http://health.dajiuxing.com.cn/health/api/upload/constant_file/djx_health_app_guide.mp4' // 视频地址
    };
  },
  mounted() {
    document.title = '绑定设备' ;
    this.getData();
    this.checkContacts();
    // 设置全局绑定设备方法
    window.bindDevice = this.bindDevice;
    // 获取心电记录仪最新状态
    this.getEcgStatus();
    // 小程序扫码绑定返回后：无论成功/失败，都刷新列表
    this.handleMiniProgramBindReturn();
  },
  activated() {
    this.handleMiniProgramBindReturn();
  },
  watch: {
    '$route'(to) {
      if (to && to.query && typeof to.query.bindSuccess !== 'undefined') {
        this.handleMiniProgramBindReturn();
      }
    }
  },
  beforeDestroy() {
    // 清除倒计时定时器
    if (this.watchBindingCountdownTimer) {
      clearInterval(this.watchBindingCountdownTimer);
      this.watchBindingCountdownTimer = null;
    }
  },
  computed: {
    ...mapState(useUserStore, ['userInfo']),
    ...mapState(useGlobalStore, ['statusBarHeight']),
    // 判断是否在APP中
    isInDjxApp() {
      return this.$env && this.$env.inDjxApp;
    },
    // 计算是否显示确定按钮
    showConfirmButton() {
      return this.contactsForm.name.trim() && this.contactsForm.phone.trim();
    }
  },
  methods: {
    
    handleMiniProgramBindReturn() {
      // 仅小程序环境处理，避免影响 APP 内嵌
      if (!(this.$env && this.$env.inMiniProgram)) return;
      const q = (this.$route && this.$route.query) ? this.$route.query : {};
      if (typeof q.bindSuccess === 'undefined') return;

      // 刷新设备列表
      this.getData();

      // 提示：成功/失败都提示一次
      const ok = String(q.bindOk || '') === '1';
      const msg = q.bindMsg ? decodeURIComponent(String(q.bindMsg)) : (ok ? '绑定成功' : '绑定失败');
      if (ok) {
        this.$message({ type: 'success', message: msg });
      } else {
        this.$message({ type: 'error', message: msg });
      }

      // 清理 URL 参数，避免重复刷新/重复提示
      try {
        this.$router.replace({ path: '/unbind', query: {} });
      } catch (e) {}
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    // 切换设备绑定状态
    toggleDeviceBinding(deviceType,status) {
      if (this.deviceBindingStatus[deviceType]) {
        console.log(status, 'status');
        // 如果已绑定，则解绑
        this.unbindDevice(deviceType);
      } else {
        // 如果未绑定，则启动扫码绑定，传递设备类型
        this.startScanBinding(deviceType);
      }
    },

    /**
     * 解绑设备
     * @param {String} deviceType - 设备类型 ('watch', 'bloodPressure', 'ecg')
     */
    unbindDevice(deviceType) {
      // 获取对应设备的详细信息
      const deviceInfo = this.deviceDetails[deviceType];
      
      if (!deviceInfo) {
        this.$message.error('设备信息不存在，无法解绑');
        return;
      }
      
      console.log('准备解绑设备:', {
        deviceType: deviceType,
        deviceInfo: deviceInfo
      });
      
      this.$confirm('确定要解绑该设备吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 构建解绑参数
        const unbindParams = {
          bindStatus: '01', // 解绑状态
          deviceCode: deviceInfo.deviceCode, // 从设备详细信息中获取
          userCode: this.userInfo.userCode,
          deviceType: deviceInfo.deviceType // 从设备详细信息中获取
        };
        
        console.log('解绑参数:', unbindParams);
        
        // 调用解绑接口
        unbindbinddevice(unbindParams).then((res) => {
          console.log('解绑响应:', res);
          if (res.code == 1000) {
            this.$message({
              type: 'success',
              message: '解绑成功!'
            });
            // 重新获取设备列表
            this.getData();
          } else {
            this.$message.error(res.message || '解绑失败');
          }
        }).catch((error) => {
          console.error('解绑设备失败:', error);
          this.$message.error('解绑失败，请重试');
        });
      }).catch(() => {
        this.$message.info('已取消解绑');
      });
    },
    // 绑定设备方法 - 从index.vue移动过来
    binding() {
      if (this.$env.inDjxApp) {
        if (this.$env.inAndroid) {
          JSInterface.actionScanCode()
        } else if (this.$env.inIos) {
          window.webkit.messageHandlers.actionScanCode.postMessage(null);
        }
      }
    },
    /**
     * 跳转到售后页面
     */
    goToAfterSales() {
      this.$router.push({
        path: '/afterSales'
      });
    },
    /**
     * 打开客服页面
     * 使用统一的在线客服链接，Android 和 iOS 都适用
     */
    openCustomerService() {
      console.log('打开客服页面');
      
      // 统一的客服链接（Android 和 iOS 都使用此链接）
      const customerServiceUrl = 'http://webchat-bj.tinetcloud.com/chat.html?accessId=50c33896-5172-49a9-a2eb-9c0a25b6c5a2&language=zh_CN';
     
      try {
        console.log('客服链接:', customerServiceUrl);
        
        // 跳转到客服页面
        window.location.href = customerServiceUrl;
        this.$message.success('正在打开客服...');
        
      } catch (error) {
        console.error('打开客服失败:', error);
        this.$message.error('打开客服失败，请重试');
      }
    },
     unbindbinddeviceclick(item) {
     
       var obj = {
         bindStatus:'03',
         deviceCode:item.deviceCode,
         userCode: localStorage.getItem('userCode'),
         deviceType:item.deviceType
       }
       unbindbinddevice(obj).then((res)=>{
         if(res.code == 1000) {
           this.$message({
             type: "success",
             message: "解绑成功!",
           });
           
           // 更新设备绑定状态
           this.updateDeviceBindingStatus(item.deviceType, false);
           
           if (this.$env.inDjxApp){
             if (this.$env.inAndroid){
               JSInterface.disBleDeviceByMac()
             }else if (this.$env.inIos) {
               window.webkit.messageHandlers.disBleDeviceByMac.postMessage(null);
             }
           }
         //   this.setUserInfo({
         //   id:this.userInfo.id,
         //   name:this.userInfo.name,
         //   userCode:this.userInfo.userCode,
         //   idNo:this.userInfo.idNo,
         //   avatar:this.userInfo.avatar,
         //   age:this.userInfo.age,
         //   sex:this.userInfo.sex,
         //   userPhone:this.userInfo.userPhone,
         //   token:this.userInfo.token,
         //   refreshToken:this.userInfo.refreshToken,
         //   isBinding:false
         // });
           this.getData()
          
         }
         console.log(res)
       })
     },
     /**
      * 获取设备绑定数据
      */
     getData() {
       // 使用新的API获取用户绑定设备列表
       getBindDeviceList().then((res) => {
         console.log('设备绑定列表响应:', res);
         if (res.code == 1000) {
           this.list = res.data || [];
           // 根据返回的设备列表更新绑定状态
           this.updateBindingStatusFromNewAPI(res.data || []);
         } else {
           console.error('获取设备列表失败:', res.message);
           this.list = [];
           this.resetDeviceBindingStatus();
         }
       }).catch((error) => {
         console.error('获取设备列表出错:', error);
         this.list = [];
         this.resetDeviceBindingStatus();
       }).finally(() => {
         // 数据加载完成后关闭加载状态
         this.isLoading = false;
       });
     },
     // 更新设备绑定状态
     updateDeviceBindingStatus(deviceType, isBound) {
       this.deviceBindingStatus[deviceType] = isBound;
     },
     // 根据设备列表更新绑定状态（旧API格式）
     updateBindingStatusFromList(deviceList) {
       if (deviceList && deviceList.length > 0) {
         // 重置所有设备状态为未绑定
         this.deviceBindingStatus = {
           watch: false,
           bloodPressure: false,
           ecg: false
         };
         
         // 根据设备类型更新绑定状态
         deviceList.forEach(device => {
           if (device.deviceType === 'watch' || device.deviceType === '1') {
             this.deviceBindingStatus.watch = true;
           } else if (device.deviceType === 'bloodPressure' || device.deviceType === '2') {
             this.deviceBindingStatus.bloodPressure = true;
           } else if (device.deviceType === 'ecg' || device.deviceType === '3') {
             this.deviceBindingStatus.ecg = true;
           }
         });
       }
     },
     
     /**
      * 根据新API返回的设备列表更新绑定状态
      * @param {Array} deviceList - 设备列表
      */
     updateBindingStatusFromNewAPI(deviceList) {
       console.log('开始处理设备列表:', deviceList);
       
       // 重置所有设备状态为未绑定
       this.resetDeviceBindingStatus();
       this.resetDeviceDetails();
       
       if (deviceList && deviceList.length > 0) {
         deviceList.forEach((device, index) => {
           console.log(`处理设备 ${index + 1}:`, {
             deviceCode: device.deviceCode,
             deviceTypeCode: device.deviceTypeCode,
             deviceTypeName: device.deviceTypeName,
             bindStatus: device.bindStatus,
             userPhone: device.userPhone
           });
           
           // 根据设备类型编码判断设备类型
           const deviceTypeCode = device.deviceTypeCode;
           const bindStatus = device.bindStatus;
           
           // 只有绑定状态为'02'（已绑定）的设备才显示为已连接
           if (bindStatus === '02') {
             console.log(`设备 ${device.deviceCode} 已绑定，设备类型编码: ${deviceTypeCode}`);
             
             // 根据设备类型编码映射到对应的设备类型
             if (this.isWatchDevice(deviceTypeCode)) {
               console.log(`✅ 设备 ${device.deviceCode} 识别为手表设备 (${deviceTypeCode})`);
               this.deviceBindingStatus.watch = true;
               this.deviceDetails.watch = {
                 deviceCode: device.deviceCode,
                 deviceType: deviceTypeCode,
                 deviceTypeName: device.deviceTypeName,
                 userPhone: device.userPhone
               };
             } else if (this.isBloodPressureDevice(deviceTypeCode)) {
               console.log(`✅ 设备 ${device.deviceCode} 识别为血压计设备 (${deviceTypeCode})`);
               this.deviceBindingStatus.bloodPressure = true;
               this.deviceDetails.bloodPressure = {
                 deviceCode: device.deviceCode,
                 deviceType: deviceTypeCode,
                 deviceTypeName: device.deviceTypeName,
                 userPhone: device.userPhone
               };
             } else if (this.isEcgDevice(deviceTypeCode)) {
               console.log(`✅ 设备 ${device.deviceCode} 识别为心电设备 (${deviceTypeCode})`);
               this.deviceBindingStatus.ecg = true;
               this.deviceDetails.ecg = {
                 deviceCode: device.deviceCode,
                 deviceType: deviceTypeCode,
                 deviceTypeName: device.deviceTypeName,
                 userPhone: device.userPhone
               };
             } else {
               console.log(`❌ 设备 ${device.deviceCode} 类型编码 ${deviceTypeCode} 未匹配到已知设备类型`);
               console.log('已知设备类型编码: 手表(10010002), 血压计(10030001), 心电(10040001)');
             }
           } else {
             console.log(`设备 ${device.deviceCode} 绑定状态为 ${bindStatus}，跳过处理`);
           }
         });
       } else {
         console.log('设备列表为空，所有设备状态重置为未绑定');
       }
       
       console.log('最终设备绑定状态:', this.deviceBindingStatus);
       console.log('设备详细信息:', this.deviceDetails);
     },
     
     /**
      * 重置设备绑定状态
      */
     resetDeviceBindingStatus() {
       this.deviceBindingStatus = {
         watch: false,
         bloodPressure: false,
         ecg: false
       };
     },
     
     /**
      * 重置设备详细信息
      */
     resetDeviceDetails() {
       this.deviceDetails = {
         watch: null,
         bloodPressure: null,
         ecg: null
       };
     },
     
     /**
      * 设备类型编码映射表
      * 根据实际设备类型编码进行映射
      */
     getDeviceTypeMapping() {
       return {
         // 手表设备类型编码
         WATCH: ['10010002'],
         // 血压仪设备类型编码  
         BLOOD_PRESSURE: ['10030001'],
         // 心电设备类型编码
         ECG: ['10040001']
       };
     },
     
     /**
      * 判断是否为手表设备
      * 设备类型编码: 10010002
      * @param {String} deviceTypeCode - 设备类型编码
      * @returns {Boolean}
      */
     isWatchDevice(deviceTypeCode) {
       const mapping = this.getDeviceTypeMapping();
       return deviceTypeCode && mapping.WATCH.includes(deviceTypeCode);
     },
     
     /**
      * 判断是否为血压仪设备
      * 设备类型编码: 10030001
      * @param {String} deviceTypeCode - 设备类型编码
      * @returns {Boolean}
      */
     isBloodPressureDevice(deviceTypeCode) {
       const mapping = this.getDeviceTypeMapping();
       return deviceTypeCode && mapping.BLOOD_PRESSURE.includes(deviceTypeCode);
     },
     
     /**
      * 判断是否为心电设备
      * 设备类型编码: 10040001
      * @param {String} deviceTypeCode - 设备类型编码
      * @returns {Boolean}
      */
     isEcgDevice(deviceTypeCode) {
       const mapping = this.getDeviceTypeMapping();
       return deviceTypeCode && mapping.ECG.includes(deviceTypeCode);
     },
     
     /**
      * 清理JSON字符串中的控制字符
      * @param {String} jsonStr - JSON字符串
      * @returns {String} 清理后的字符串
      */
     cleanJsonString(jsonStr) {
       // 使用正则表达式移除控制字符
       return jsonStr.replace(/[\x00-\x1F\x7F]/g, '');
     },
     
     /**
      * 绑定设备方法
      * @param {String} str - 二维码扫码数据
      */
     bindDevice(str) {
       console.log(str, '二维码扫码数据');
       console.log('当前绑定的设备类型:', this.currentBindingDeviceType);
       
       // 根据页面点击的设备类型确定deviceType参数
       let deviceTypeCode = '';
       if (this.currentBindingDeviceType === 'watch') {
         deviceTypeCode = '10010002'; // 手表
       } else if (this.currentBindingDeviceType === 'bloodPressure') {
         deviceTypeCode = '10030001'; // 血压仪
       } else if (this.currentBindingDeviceType === 'ecg') {
         deviceTypeCode = '10040001'; // 心电记录仪
       } else {
         console.error('未知的设备类型:', this.currentBindingDeviceType);
         this.$message.error('设备类型错误');
         return;
       }
       
       console.log('使用的设备类型编码:', deviceTypeCode);
       
       // 构建绑定参数
       const bindParams = {
         deviceCode: '',
         deviceType: deviceTypeCode,
         bindStatus: '02',
         jsonBrs: str
       };
       
       console.log('设备绑定参数:', bindParams);
       
       // 调用绑定接口
       binddevice(bindParams).then((res) => {
         console.log('绑定设备响应:', res);
         if (res.code == 1000) {
           this.$message({
             type: "success",
             message: "绑定成功!"
           });
           
           // 更新用户信息
           this.setUserInfo({
             id: this.userInfo.id,
             name: this.userInfo.name,
             userCode: this.userInfo.userCode,
             idNo: this.userInfo.idNo,
             avatar: this.userInfo.avatar,
             age: this.userInfo.age,
             sex: this.userInfo.sex,
             userPhone: this.userInfo.userPhone,
             token: this.userInfo.token,
             refreshToken: this.userInfo.refreshToken,
             isBinding: true
           });
           
           // 重新获取设备列表
           this.getData();
           
           // 清空当前绑定设备类型
           this.currentBindingDeviceType = null;
         } else {
           this.$message.error(res.message || '绑定失败');
         }
       }).catch((error) => {
         console.error('绑定设备失败:', error);
         this.$message.error('绑定失败，请重试');
       });
     },
     
   /**
    * 启动扫码绑定
    * @param {String} deviceType - 设备类型 ('watch', 'bloodPressure', 'ecg')
    */
   startScanBinding(deviceType) {
     // 将设备类型保存到实例中，供bindDevice方法使用
     this.currentBindingDeviceType = deviceType;
     
     // 如果是心电设备，显示使用步骤弹窗
     if (deviceType === 'ecg') {
       this.showGuideDialog();
       return;
     }
     
     // 智能手表：显示绑定提醒弹框后扫码
     if (deviceType === 'watch') {
       this.showWatchBindingReminder();
       return;
     }
     
     // 其他设备直接扫码
     this.proceedWithScanCode();
   },
   
   /**
    * 显示智能手表绑定提醒弹框
    */
   showWatchBindingReminder() {
     // 重置倒计时
     this.watchBindingCountdown = 5;
     this.watchBindingReminderDialog = true;
     
     // 清除之前的定时器
     if (this.watchBindingCountdownTimer) {
       clearInterval(this.watchBindingCountdownTimer);
     }
     
     // 开始倒计时
     this.watchBindingCountdownTimer = setInterval(() => {
       this.watchBindingCountdown--;
       if (this.watchBindingCountdown <= 0) {
         clearInterval(this.watchBindingCountdownTimer);
         this.watchBindingCountdownTimer = null;
       }
     }, 1000);
   },
   
  /**
   * 关闭智能手表绑定提醒弹框并继续扫码
   */
  closeWatchBindingReminder() {
    // 清除定时器
    if (this.watchBindingCountdownTimer) {
      clearInterval(this.watchBindingCountdownTimer);
      this.watchBindingCountdownTimer = null;
    }
    
    // 关闭弹框
    this.watchBindingReminderDialog = false;
    
    // 继续扫码流程
    this.proceedWithScanCode();
  },
   
   /**
    * 继续扫码流程
    */
   proceedWithScanCode() {
     // 微信小程序环境：跳转到小程序扫码页（小程序端扫码后调用绑定接口，成功后回到本页刷新）
     if (this.$env && this.$env.inMiniProgram) {
       try {
         if (typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.navigateTo === 'function') {
           const token = localStorage.getItem('token') || '';
           const apiBase = (typeof window !== 'undefined' && window.SEVSRS) ? window.SEVSRS : '';
           // 传 hash 与 origin 拼成 returnUrl，避免完整 href 过长被截断
           const baseH5 = (window.location.origin || '') + (window.location.pathname || '');
           const hashPart = window.location.hash || '#/unbind';
           const params = [
             'baseH5=' + encodeURIComponent(baseH5),
             'hashPart=' + encodeURIComponent(hashPart),
             'token=' + encodeURIComponent(token),
             'deviceType=' + encodeURIComponent(this.currentBindingDeviceType || ''),
             'apiBase=' + encodeURIComponent(apiBase)
           ].filter(p => p.length > 0).join('&');
           wx.miniProgram.navigateTo({
             url: '/pages/scan/index?' + params
           });
         } else {
           this.$message.error('请在微信小程序中打开');
         }
       } catch (e) {
         console.warn('小程序扫码跳转失败:', e);
         this.$message.error('扫码打开失败，请重试');
       }
       return;
     }

     // 调用原生扫码功能
     if (this.$env.inDjxApp) {
       if (this.$env.inAndroid) {
         JSInterface.actionScanCode();
       } else if (this.$env.inIos) {
         window.webkit.messageHandlers.actionScanCode.postMessage(null);
       }
     } else {
       this.$message.error('请在APP中使用扫码功能');
     }
   },
   
   /**
    * 显示使用步骤弹窗
    */
   showGuideDialog() {
     // 重置到第一步
     this.currentStepIndex = 0;
     this.guideDialog = true;
     
     // 确保 Swipe 组件也重置到第一步
     this.$nextTick(() => {
       if (this.$refs.guideSwipe) {
         this.$refs.guideSwipe.swipeTo(0);
       }
     });
   },
   
   /**
    * 跳过当前步骤
    * 直接跳到第四步（连接记录仪页面）
    */
   skipGuide() {
     // 直接跳到第四步（索引3）
     this.$nextTick(() => {
       if (this.$refs.guideSwipe) {
         this.$refs.guideSwipe.swipeTo(3);
       }
     });
   },
   
   /**
    * 跳转到下一步
    */
   goToNextStep() {
     if (this.currentStepIndex < 3) {
       // 使用 ref 调用 Swipe 组件的 swipeTo 方法切换到下一步
       this.$nextTick(() => {
         if (this.$refs.guideSwipe) {
           this.$refs.guideSwipe.swipeTo(this.currentStepIndex + 1);
         }
       });
     }
   },
   
   /**
    * 步骤切换事件
    * @param {Number} index - 当前步骤索引
    */
   onStepChange(index) {
     this.currentStepIndex = index;
   },
   
   /**
    * 连接记录仪
    */
   connectDevice() {
     this.guideDialog = false;
     this.jumpToWeChatMiniProgram();
   },
   
   /**
    * 关闭使用步骤弹窗
    */
   closeGuideDialog() {
     this.guideDialog = false;
   },
    
    /**
     * 跳转到微信小程序
     * 用于心电设备蓝牙连接
     * 参考微信官方文档：https://developers.weixin.qq.com/miniprogram/dev/framework/open-ability/url-scheme.html
     */
    async jumpToWeChatMiniProgram() {
      // 小程序 webview 环境：通过桥接页跳转（postMessage 仅在页面关闭时触发，无法即时跳转）
      if (this.$env && this.$env.inMiniProgram && typeof wx !== 'undefined' && wx.miniProgram && typeof wx.miniProgram.navigateTo === 'function') {
        try {
          const userPhone = (this.userInfo && this.userInfo.userPhone) ? encodeURIComponent(this.userInfo.userPhone) : '';
          wx.miniProgram.navigateTo({
            url: '/pages/bridge/index?action=openEcg&userPhone=' + userPhone
          });
        } catch (e) {
          console.warn('小程序桥接页跳转失败', e);
          this.$message.error('打开失败，请重试');
        }
        return;
      }

      // 获取心电设备的小程序配置信息
      const miniProgramConfig = getMiniProgramConfig('ecg');
      
      console.log('开始跳转微信小程序，配置信息:', miniProgramConfig);
      
      // 环境检测
      const userAgent = navigator.userAgent.toLowerCase();
      const isWeChat = userAgent.includes('micromessenger');
      
      console.log('环境检测:', { isWeChat });
      
      if (isWeChat) {
        // 在微信内，使用开放标签（推荐）
        this.launchInWeChat(miniProgramConfig);
      } else {
        // 在微信外（APP内），使用明文URL Scheme
        this.launchWithPlainTextScheme(miniProgramConfig);
      }
    },
    
    /**
     * 在微信内使用开放标签跳转
     * @param {Object} config - 小程序配置
     */
    launchInWeChat(config) {
      console.log('在微信内使用开放标签跳转');
      
      // 检查微信JS-SDK是否加载
      if (typeof wx === 'undefined') {
        console.error('微信JS-SDK未加载');
        this.fallbackLaunch(config);
        return;
      }
      
      // 获取用户手机号并构建带参数的页面路径
      const userPhone = this.userInfo.userPhone || '';
      const pathWithParams = this.buildPathWithUserPhone(config.path, userPhone);
      console.log('用户手机号:', userPhone);
      console.log('页面路径:', pathWithParams);
      
      // 创建wx-open-launch-weapp标签
      const wxTag = document.createElement('wx-open-launch-weapp');
      wxTag.setAttribute('username', config.originalId);
      wxTag.setAttribute('path', pathWithParams);
      
      // 创建按钮
      const button = document.createElement('button');
      button.textContent = '正在跳转到小程序...';
      button.style.cssText = `
        width: 100%;
        height: 40px;
        background: #07c160;
        color: white;
        border: none;
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
      `;
      
      wxTag.appendChild(button);
      document.body.appendChild(wxTag);
      
      // 监听事件
      wxTag.addEventListener('launch', (e) => {
        console.log('小程序启动成功');
        this.$message.success('正在跳转到小程序...');
      });
      
      wxTag.addEventListener('error', (e) => {
        console.error('小程序启动失败:', e.detail);
        this.fallbackLaunch(config);
      });
      
      // 自动点击
      setTimeout(() => button.click(), 100);
      
      // 清理
      setTimeout(() => {
        if (document.body.contains(wxTag)) {
          document.body.removeChild(wxTag);
        }
      }, 5000);
    },
    
    /**
     * 构建带用户手机号的页面路径
     * @param {String} basePath - 基础页面路径
     * @param {String} userPhone - 用户手机号
     * @returns {String} 带参数的页面路径
     */
    buildPathWithUserPhone(basePath, userPhone) {
      if (!userPhone) {
        return basePath;
      }
      
      // 构建查询参数
      const params = new URLSearchParams({
        userPhone: userPhone
      });
      
      // 如果有参数，添加到路径中
      const queryString = params.toString();
      return queryString ? `${basePath}?${queryString}` : basePath;
    },
    
    /**
     * 使用明文URL Scheme跳转（微信外使用）
     * @param {Object} config - 小程序配置
     */
    launchWithPlainTextScheme(config) {
      console.log('使用明文URL Scheme跳转');
      
      // 生成明文URL Scheme
      const plainTextScheme = 'weixin://dl/business/?appid=wx5d984a32674e2a19&path=pages/index/index&query=userPhone%3D' + this.userInfo.userPhone;
      console.log('明文URL Scheme:', plainTextScheme);
      
      // 检测是否为 iOS 系统
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      console.log('系统检测:', { isIOS });
      
      // iOS 系统使用 a 标签点击方式跳转
      if (isIOS) {
        this.launchWithAndroid(plainTextScheme);
      } else {
        // Android 系统使用 window.location.href 方式
        this.launchWithAndroid(plainTextScheme);
      }
    },
    
    /**
     * iOS 系统跳转方式
     * @param {String} scheme - URL Scheme
     */
    launchWithIOS(scheme) {
      console.log('iOS系统：使用a标签方式跳转');
      
      try {
        // 创建隐藏的 a 标签
        const link = document.createElement('a');
        link.href = scheme;
        link.style.display = 'none';
        document.body.appendChild(link);
        
        // 触发点击
        link.click();
        
        // 显示提示
        this.$message.success('正在打开微信小程序...');
        
        // 延迟清理
        setTimeout(() => {
          if (document.body.contains(link)) {
            document.body.removeChild(link);
          }
        }, 1000);
        
        // iOS 备用方案：如果 a 标签不生效，尝试 iframe 方式
        setTimeout(() => {
          console.log('iOS备用方案：使用iframe方式');
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = scheme;
          document.body.appendChild(iframe);
          
          setTimeout(() => {
            if (document.body.contains(iframe)) {
              document.body.removeChild(iframe);
            }
          }, 2000);
        }, 500);
        
      } catch (error) {
        console.error('iOS跳转失败:', error);
        this.$message.error('打开微信小程序失败，请确保已安装微信');
      }
    },
    
    /**
     * Android 系统跳转方式
     * @param {String} scheme - URL Scheme
     */
    launchWithAndroid(scheme) {
      console.log('Android系统：使用window.location方式跳转');
      
      try {
        window.location.href = scheme;
        this.$message.success('正在打开微信小程序...');
      } catch (error) {
        console.error('Android跳转失败:', error);
        this.$message.error('打开微信小程序失败，请确保已安装微信');
      }
    },
    
    /**
     * 显示跳转失败对话框
     * @param {Object} config - 小程序配置
     */
    showJumpFailedDialog(config) {
      this.$confirm(
        `无法跳转到微信小程序，可能的原因：\n\n1. 小程序页面路径不存在\n2. 小程序未发布或权限问题\n3. 微信版本不支持\n4. 需要在微信小程序管理后台开启"明文Scheme拉起此小程序"\n\n当前配置：\nAppID: ${config.appId}\n原始ID: ${config.originalId}\n页面路径: ${config.path}\n\n建议：\n1. 检查小程序是否已发布\n2. 在MP平台开启明文Scheme功能\n3. 验证页面路径是否正确`,
        '跳转失败',
        {
          confirmButtonText: '复制信息',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.copyMiniProgramInfo(config);
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    
    /**
     * 复制小程序信息
     * @param {Object} config - 小程序配置
     */
    copyMiniProgramInfo(config) {
      const info = `小程序名称：${config.name}\nAppID：${config.appId}\n原始ID：${config.originalId}\n页面路径：${config.path}`;
      
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(info).then(() => {
          this.$message.success('小程序信息已复制到剪贴板');
        }).catch(() => {
          this.showManualCopyDialog(info);
        });
      } else {
        this.showManualCopyDialog(info);
      }
    },
    
    /**
     * 显示手动复制对话框
     * @param {String} text - 要复制的文本
     */
    showManualCopyDialog(text) {
      this.$alert(
        `请手动复制以下信息：\n\n${text}\n\n复制后，请打开微信并搜索小程序。`,
        '手动复制小程序信息',
        {
          confirmButtonText: '我知道了',
          type: 'info'
        }
      );
    },
    
    /**
     * 备选方案：引导用户手动打开或使用其他方法
     * @param {Object} config - 小程序配置
     */
    fallbackLaunch(config) {
      console.log('Scheme打开失败，使用备选方案:', config);
      
      // 备选方案：引导用户手动打开或使用其他方法
      this.$alert(`无法直接唤起小程序，请手动打开微信搜索小程序：${config.name}`, '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      });
    },
    
    
    /**
     * 检查紧急联系人
     */
    async checkContacts() {
      try {
        // 先检查设备绑定信息
        const bindRes = await binddeviceinfo();
        if (bindRes.code === '1000') {
          // 检查是否有 data 并且 isDaoAn 为 true
          if (bindRes.data && bindRes.data.isDaoAn === true) {
            // 满足条件，继续检查紧急联系人
            const contactsRes = await contacts();
            if (contactsRes.code === '1000') {
              // 如果 data 数组为空或者不存在，显示添加紧急联系人的弹出框
              if (!contactsRes.data || !contactsRes.data.length) {
                this.contactsDialog = true;
              }
            }
          }
          // 如果 isDaoAn 不为 true，不弹出紧急联系人弹框
        }
      } catch (error) {
        console.error('检查紧急联系人失败:', error);
      }
    },
    /**
     * 获取心电记录仪最新状态
     */
    async getEcgStatus() {
      if (!this.userInfo.userCode) {
        return;
      }
      try {
        const res = await getSwkMeasurementsByUser({
          userCode: this.userInfo.userCode,
          pageIndex: 1,
          pageSize: 1
        });
        let item = null;
        if (res && (res.code == 1000 || res.code === 'OK')) {
          if (Array.isArray(res.data) && res.data.length > 0) {
            item = res.data[0];
          } else if (res.data && Array.isArray(res.data.list) && res.data.list.length > 0) {
            item = res.data.list[0];
          }
        }
        if (item) {
          // 判断是否在两天内
          const recordTime = new Date(item.recordStartTime);
          const now = new Date();
          const diffTime = now - recordTime;
          const diffDays = diffTime / (1000 * 60 * 60 * 24);
          
          if (diffDays <= 2) {
            // 在两天内，根据状态显示文字
            this.ecgStatus = this.getEcgStatusText(item);
          } else {
            // 不在两天内，不显示状态
            this.ecgStatus = null;
          }
        } else {
          this.ecgStatus = null;
        }
      } catch (error) {
        console.error('获取心电记录仪状态失败:', error);
        this.ecgStatus = null;
      }
    },
    
    /**
     * 根据心电记录仪数据获取状态文字
     * @param {Object} item - 心电记录仪数据
     * @returns {String} 状态文字
     */
    getEcgStatusText(item) {
      // completed: 是否已完成（数据上传）
      // labeled: 是否已标注（已判图）
      // pdfFilePath: PDF文件路径
      
      // 1. 检测中待上传 - 未完成上传
      if (!item.completed) {
        return '检测中,待上传';
      }
      
      // 3. 报告已生成 - 已完成、已判图、有PDF
      if (item.completed && item.labeled && item.pdfFilePath) {
        return '报告已生成';
      }
      
      // 2. 已上传报告生成中 - 已完成但未判图，或者已完成已判图但无PDF
      if (item.completed) {
        return '已上传,报告生成中';
      }
      
      // 默认：检测中待上传
      return '检测中待上传';
    },
    
    /**
     * 添加紧急联系人
     */
    async addEmergencyContact() {
      // 手机号格式验证
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.contactsForm.phone)) {
        this.$toast('请输入正确的手机号格式');
        return;
      }
      
      try {
        const res = await addcontacts({
          contactName: this.contactsForm.name,
          contactPhone: this.contactsForm.phone
        });
        if (res.code === '1000') {
          this.$toast('添加成功');
          // 重置表单
          this.contactsForm = {
            name: '',
            phone: ''
          };
          // 关闭弹框
          this.contactsDialog = false;
        } else {
          this.$toast(res.message || '添加失败，请重试');
        }
      } catch (error) {
        console.error('添加紧急联系人失败:', error);
        this.$toast('添加失败，请重试');
      }
    },
    ...mapActions(useUserStore, ['setUserInfo']),
    /**
     * 切换视频播放状态
     */
    toggleVideoPlay() {
      // 使用HTML5视频播放（APP中也使用，通过属性配置支持全屏）
      if (!this.isVideoPlaying) {
        this.isVideoPlaying = true;
        this.$nextTick(() => {
          const video = this.isInDjxApp ? this.$refs.videoPlayerApp : this.$refs.videoPlayer;
          if (video) {
            video.play().catch(error => {
              console.error('视频播放失败:', error);
              this.$message.error('视频播放失败，请重试');
            });
          }
        });
      }
    },
    /**
     * 视频开始播放
     */
    onVideoPlay() {
      this.isVideoPlaying = true;
      // 在APP中，尝试触发全屏播放（某些情况下需要用户手动点击全屏按钮）
      if (this.isInDjxApp) {
        this.$nextTick(() => {
          const video = this.$refs.videoPlayerApp;
          if (video) {
            // 对于X5内核，使用native模式应该自动支持全屏
            // 如果全屏按钮仍然不可用，可能是WebView配置问题
            console.log('视频开始播放，全屏按钮应该可用');
          }
        });
      }
    },
    /**
     * 视频暂停
     */
    onVideoPause() {
      // 暂停时保持播放状态，让用户可以通过控制栏控制
    },
    /**
     * 视频播放结束
     */
    onVideoEnd() {
      this.isVideoPlaying = false;
    },
    /**
     * 请求全屏播放
     */
    requestFullscreen() {
      // 如果在APP中，点击播放时会使用原生播放器，原生播放器自带全屏功能
      if (this.$env && this.$env.inDjxApp) {
        this.toggleVideoPlay();
        return;
      }
      
      const video = this.$refs.videoPlayer;
      if (!video) {
        return;
      }
      
      try {
        // 尝试使用标准全屏API
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
          // WebKit浏览器（Safari）
          video.webkitRequestFullscreen();
        } else if (video.webkitEnterFullScreen) {
          // iOS Safari
          video.webkitEnterFullScreen();
        } else if (video.mozRequestFullScreen) {
          // Firefox
          video.mozRequestFullScreen();
        } else if (video.msRequestFullscreen) {
          // IE/Edge
          video.msRequestFullscreen();
        } else {
          // 如果都不支持，尝试点击视频元素来触发全屏
          video.click();
        }
      } catch (error) {
        console.error('请求全屏失败:', error);
        // 降级方案：直接点击视频元素
        video.click();
      }
    }
  },
};
</script>
<style scoped>
.device-management-page {
  min-height: 100vh;
  background-color: #F2F3F5;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

/* 顶部导航栏 - 参考 information 页面 */
.device-header {
  position: relative;
  width: 100%;
  min-height: 220px;
  overflow: hidden;
  margin-bottom: 0;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.header-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.header-nav {
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  min-height: 44px;
}

.nav-back-wrapper {
  flex-shrink: 0;
}

.nav-back-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  color: #000000;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-back-btn i {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}

.nav-back-btn:hover {
  background: #f5f5f5;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-back-btn:active {
  transform: translateY(0) scale(0.95);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.nav-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}

.nav-after-sales {
  flex-shrink: 0;
  padding: 6px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-after-sales:hover {
  background: #ffffff;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-after-sales:active {
  transform: translateY(0) scale(0.95);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.nav-after-sales span {
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

/* 移动端H5设备列表 - 专门优化 */
.mobile-device-list {
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: absolute;
  top: 0px;
  z-index: 10;
}

.mobile-device-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #F0F0F0;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 116px;
  position: relative;
  overflow: hidden;
  
  &:active {
    transform: scale(0.98);
    background: #F8F9FA;
  }
  
  &.device-connected {
    /* border-color: #00C275; */
    background: #ffffff;
    box-shadow: 0 2px 12px rgba(0, 194, 117, 0.1);
  }
}

/* 已连接标签样式 */
.connected-badge {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 103px;
  height: 21px;
  background: url('~@/assets/deviceList/boundBackground.png') no-repeat center center;
  background-size: 100% 100%;
  color: #ffffff;
  font-size: 11px;
  font-weight: 500;
  z-index: 10;
  
  .check-icon {
    width: 13px;
    height: 13px;
    object-fit: contain;
  }
}

.device-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  margin-top: 15px;
}

.device-avatar {
  position: relative;
  width: 60px;
  height: 60px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F8F9FA;
  border-radius: 12px;
  flex-shrink: 0;
}

.device-image {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.device-info {
  flex: 1;
  min-width: 0;
}

.device-title {
  font-size: 16px;
  font-weight: 600;
  color: #2C3E50;
  margin: 0 0 4px 0;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.device-subtitle {
  font-size: 12px;
  color: #8E8E93;
  margin: 0 0 4px 0;
  line-height: 1.2;
}

.device-imei {
  font-size: 12px;
  color: #666666;
  margin: 4px 0 0 0;
  line-height: 1.2;
}

.device-status-text {
  font-size: 12px;
  color: #00C275;
  margin: 4px 0 0 0;
  line-height: 1.2;
  font-weight: 500;
}

.device-right {
  flex-shrink: 0;
  margin-left: 12px;
}

/* 移动端按钮样式 - 触摸友好 */
.mobile-action-btn {
  color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: 70px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  
  /* 绑定/开始测量按钮 - 背景色通过行内样式设置 */
  &.bind-btn,
  &.start-measure-btn {
    &:active {
      transform: scale(0.95);
      box-shadow: 0 1px 4px rgba(0, 194, 117, 0.3);
      opacity: 0.9;
    }
  }
  
  /* 解绑按钮 - 背景色通过行内样式设置 */
  &.unbind-btn {
    &:active {
      transform: scale(0.95);
      opacity: 0.9;
      box-shadow: 0 1px 4px rgba(255, 107, 157, 0.3);
    }
  }
}

.group_1 {
  margin-left: 5px;
}

.text_1 {
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 15px;
  letter-spacing: -0.30000001192092896px;
  font-family: SFProText-Semibold;
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
  line-height: 18px;
}

.thumbnail_1 {
  width: 17px;
  height: 11px;
  margin: 4px 0 3px 219px;
}

.thumbnail_2 {
  width: 15px;
  height: 11px;
  margin: 3px 0 4px 5px;
}

.image_1 {
  width: 25px;
  height: 12px;
  margin: 3px 0 3px 5px;
}

.text_2 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 24px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: justify;
  white-space: nowrap;
  line-height: 33px;
  margin: 26px 249px 0 0;
  position: absolute;
}

.group_2 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  width: 343px;
  margin-top: 13px;
  padding: 24px 30px 24px 30px;
  /* position: absolute;
    top: 90px; */
}

.image-text_1 {
  display: flex;
    align-items: center;
}

.image_2 {
  width: 50px;
  height: 66px;
  margin-left:-17px
}
.image_3 {
  margin-left:-17px;
  width:109%
}
.group_3 {
  margin: 9px 0 9px 0;
  margin-left: 16px;
}

.text-group_1 {
  overflow-wrap: break-word;
  color: #333333;
  font-size: 16px;
  font-weight: normal;
  font-family: PingFangSC-Medium;
  text-align: justify;
  white-space: nowrap;
  font-style: normal;
  line-height: 20px;
}

.text-wrapper_1 {
  /* width:84px; */
  height: 24px;
  line-height: 21px;
  border-radius: 16px;
  background: #22C089;
  margin: 10px 0 0 0;
  padding: 2px 11px 3px 11px;
  display: inline-block;
  overflow-wrap: break-word;
  color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  text-align: justify;
  white-space: nowrap;
}

.listDiv {
  position: absolute;
    top: 85px;
}

.text_4 {
  overflow-wrap: break-word;
  color: #FA7205;
  font-size: 14px;
  font-weight: normal;
  text-align: justify;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 41px;
  /* margin-top: 26px; */
}
.dl {
  font-size: 13px;
}

/* 优化紧急联系人弹出框样式 */
.contacts-dialog {
  padding: 24px 20px;
  background: #ffffff;
  border-radius: 20px;
}

.contacts-tip {
  font-size: 15px;
  color: #4A5568;
  line-height: 1.6;
  margin-bottom: 24px;
  text-align: center;
  font-weight: 500;
}

.contacts-form .contacts-input {
  background: #F7FAFC;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  margin-bottom: 16px;
  transition: all 0.3s ease;
  
  &:focus-within {
    border-color: #00C275;
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(0, 194, 117, 0.1);
  }
}

.contacts-form .contacts-input:last-child {
  margin-bottom: 0;
}

/* 优化自定义按钮样式 */
.contacts-button-wrapper {
  margin-top: 24px;
}

.contacts-confirm-btn {
  height: 48px;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 194, 117, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
}



/* 加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 200px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E2E8F0;
  border-top: 3px solid #00C275;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: #8E8E93;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  text-align: center;
}


/* 使用步骤弹窗样式 */
.guide-dialog {
  width: 90%;
  max-width: 400px;
  border-radius: 16px;
  overflow: hidden;
}

.guide-dialog >>> .van-dialog__content {
  padding: 0;
}

.guide-content {
  width: 100%;
  height: 100%;
  background: #ffffff;
  position: relative;
}

/* 滑动提示 */
.swipe-hint {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: rgba(0, 194, 117, 0.9);
  color: #ffffff;
  font-size: 12px;
  border-radius: 20px;
  z-index: 100;
  animation: swipeHintBounce 2s ease-in-out infinite;
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
  
  i {
    font-size: 14px;
    animation: arrowMove 1.5s ease-in-out infinite;
  }
  
  i.el-icon-d-arrow-left {
    animation-direction: reverse;
  }
}

/* 提示弹跳动画 */
@keyframes swipeHintBounce {
  0%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-3px);
  }
}

/* 箭头左右移动动画 */
@keyframes arrowMove {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(3px);
  }
}

.guide-swipe {
  height: 500px;
  background: #ffffff;
}

.swipe-item-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.guide-image {
  width: 100%;
  height: 480px;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}

.skip-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  transition: all 0.3s ease;
  z-index: 10;
  
  &:active {
    background: rgba(0, 0, 0, 0.5);
  }
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 20px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 10;
  
  &:active {
    background: rgba(0, 0, 0, 0.5);
    transform: scale(0.95);
  }
  
  i {
    font-weight: bold;
  }
}

.guide-text {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 90%;
  text-align: center;
  padding: 20px;
}

.guide-title {
  font-size: 22px;
  font-weight: 600;
  color: #2C3E50;
  margin: 0 0 20px 0;
  line-height: 1.4;
}

.guide-desc {
  font-size: 14px;
  color: #5A5A5A;
  margin: 5px 0;
  line-height: 1.6;
}

.guide-action {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  text-align: center;
}

.connect-btn,
.next-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #00C275 0%, #4ECDC4 100%);
  box-shadow: 0 4px 12px rgba(0, 194, 117, 0.3);
  transition: all 0.3s ease;
  
  &:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(0, 194, 117, 0.4);
  }
}

/* 移动端优化 */
@media (max-width: 375px) {
  .guide-swipe {
    height: 450px;
  }
  
  .guide-image {
    height: 240px;
  }
  
  .guide-title {
    font-size: 20px;
  }
  
  .guide-desc {
    font-size: 13px;
  }
  
  .guide-action {
    width: 70%;
  }
}

@media (max-width: 320px) {
  .guide-swipe {
    height: 400px;
  }
  
  .guide-image {
    height: 200px;
  }
  
  .guide-title {
    font-size: 18px;
  }
  
  .guide-desc {
    font-size: 12px;
  }
  
  .guide-action {
    width: 75%;
    bottom: 30px;
  }
  
  .connect-btn,
  .next-btn {
    height: 44px;
    font-size: 15px;
  }
}

/* 视频播放区域样式 */
.video-player-section {
  width: 100%;
  margin-top: 12px;
}

.video-player-container {
  position: relative;
  width: 100%;
  max-width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #000000;
  cursor: pointer;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-poster {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  /* 允许全屏播放 */
  -webkit-tap-highlight-color: transparent;
}

/* 全屏播放时的样式 */
.video-player:-webkit-full-screen {
  width: 100vw;
  height: 100vh;
  object-fit: contain;
}

.video-player:-moz-full-screen {
  width: 100vw;
  height: 100vh;
  object-fit: contain;
}

.video-player:-ms-fullscreen {
  width: 100vw;
  height: 100vh;
  object-fit: contain;
}

.video-player:fullscreen {
  width: 100vw;
  height: 100vh;
  object-fit: contain;
}

.video-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
}

.video-play-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: translate(-50%, -50%) scale(1.1);
}

.video-play-btn:active {
  transform: translate(-50%, -50%) scale(0.95);
}

.play-icon {
  color: #ffffff;
  font-size: 24px;
  margin-left: 4px;
  line-height: 1;
}

.video-fullscreen-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 20;
}

.video-fullscreen-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.video-fullscreen-btn:active {
  transform: scale(0.95);
}

.fullscreen-icon {
  color: #ffffff;
  font-size: 20px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/binding/unbind.vue